// import React from 'react';
import { X } from 'lucide-react';

const RightSidebar = ({ isOpen, onClose, children }) => {
  return (
    <>
      <div
        className={`fixed top-0 right-0 h-full bg-white dark:bg-gray-800 shadow-2xl transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } w-full md:w-1/2 lg:w-1/3`}
        style={{ zIndex: 1000 }}
      >
        {/* Close Button (fixed at top) */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          <X size={24} />
        </button>

        {/* Scrollable Content */}
        <div className="h-full pt-12 overflow-y-auto px-6 pb-6">
          {children}
        </div>
      </div>

      {/* Dark Overlay */}
      {isOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black opacity-50"
          onClick={onClose}
          style={{ zIndex: 999 }}
        ></div>
      )}
    </>
  );
};

export default RightSidebar;
